module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-whiteframe', {
    staticClass: "container",
    attrs: {
      "md-elevation": "4"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('md-icon', {
    staticClass: "setting",
    nativeOn: {
      "click": function($event) {
        _vm.toggleRightSidenav($event)
      }
    }
  }, [_vm._v("settings")]), _vm._v(" "), _c('div', {
    staticClass: "header-tip"
  }, [_vm._v(_vm._s(_vm.isWorkTime ? _vm.tipWorkText : _vm.tipRestText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "task-area"
  }, [_c('div', [_vm._v(_vm._s(_vm.taskName))])]), _vm._v(" "), _c('div', {
    staticClass: "time-area"
  }, _vm._l((_vm.toMinutsText), function(word, index) {
    return _c('div', {
      key: index,
      staticClass: "time-item"
    }, [_vm._v(_vm._s(word))])
  })), _vm._v(" "), _c('div', {
    staticClass: "control-area"
  }, [_c('md-layout', {
    staticClass: "control-play",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "33"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-primary"
  }, [_c('md-icon', {
    staticClass: "md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.stopTomato($event)
      }
    }
  }, [_vm._v("stop")])], 1)], 1), _vm._v(" "), _c('md-layout', [_c('md-button', {
    staticClass: "md-fab",
    nativeOn: {
      "click": function($event) {
        _vm.toggleTomato($event)
      }
    }
  }, [_c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPause),
      expression: "isPause"
    }]
  }, [_vm._v("play_arrow")]), _vm._v(" "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPause),
      expression: "!isPause"
    }]
  }, [_vm._v("pause")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "33"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-primary"
  }, [_c('md-icon', {
    staticClass: "md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.nextTomato($event)
      }
    }
  }, [_vm._v("skip_next")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('md-sidenav', {
    ref: "rightSidenav",
    staticClass: "md-right"
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("番茄时钟设置")])])]), _vm._v(" "), _c('div', {
    staticClass: "setting-container"
  }, [_c('div', {
    staticClass: "setting-focus-time"
  }, [_c('md-input-container', [_c('label', [_vm._v("专注时间(分钟)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "设置专注时间"
    },
    model: {
      value: (_vm.settingFocusTime),
      callback: function($$v) {
        _vm.settingFocusTime = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "settingFocusTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "setting-rest-time"
  }, [_c('md-input-container', [_c('label', [_vm._v("休息时间(分钟)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "设置休息时间"
    },
    model: {
      value: (_vm.settingRestTime),
      callback: function($$v) {
        _vm.settingRestTime = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "settingRestTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.saveSetting($event)
      }
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-58cedaf0"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/Tomato.vue
// module id = 349
// module chunks = 1